import React from 'react';
import Box from '@mui/material/Box';
import MensDivision from './Mens';
import WomensDivision from './Womens';
import MixDivision from './Mix';

const Participants = ({ data, viewData, tournamentDetails }) => {
  const menDivision = data.filter((item) => item.tournament_gender === 'men');
  const womenDivision = data.filter(
    (item) => item.tournament_gender === 'women',
  );
  const mixDivision = data.filter((item) => item.tournament_gender === 'mix');

  return (
    <Box width={'100%'}>
      {tournamentDetails.men_enabled === 1 && (
        <MensDivision
          menDivision={menDivision}
          viewData={viewData}
          menLevels={tournamentDetails.men_levels}
        />
      )}
      {tournamentDetails.women_enabled === 1 && (
        <Box marginTop={{ xs: '64px', md: '96px' }}>
          <WomensDivision
            womenDivision={womenDivision}
            viewData={viewData}
            womenLevels={tournamentDetails.women_levels}
          />
        </Box>
      )}
      {tournamentDetails.mix_enabled === 1 && (
        <Box marginTop={{ xs: '64px', md: '96px' }}>
          <MixDivision
            mixDivision={mixDivision}
            viewData={viewData}
            mixLevels={tournamentDetails.mix_levels}
          />
        </Box>
      )}
    </Box>
  );
};

export default Participants;
